module.exports = __webpack_public_path__ + "static/media/celu2.8ac7cbaa.png";